import { render, staticRenderFns } from "./Chancellor.vue?vue&type=template&id=ac381a30&"
import script from "./Chancellor.vue?vue&type=script&lang=js&"
export * from "./Chancellor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports